var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpDesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.67,
    height: 17.67,
    viewBox: "0 0 17.67 17.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.835,0A8.893,8.893,0,0,0,0,8.9v3.559a2.608,2.608,0,0,0,2.587,2.606,2.608,2.608,0,0,0,2.587-2.606v-1.78A2.608,2.608,0,0,0,2.587,8.072H1.7a7.178,7.178,0,0,1,14.262,0h-.884A2.608,2.608,0,0,0,12.5,10.678v1.78a2.608,2.608,0,0,0,2.587,2.606,2,2,0,0,0,.884-.191c-.126,1.144-.631,1.144-.884,1.144H10.665a.826.826,0,0,0,0,1.653h4.418c.947,0,2.587-.445,2.587-3.5V8.9A8.893,8.893,0,0,0,8.835,0Zm5.3,10.678a.974.974,0,0,1,.947-.953h.947v2.733a.947.947,0,1,1-1.893,0Zm-10.6,1.78a.974.974,0,0,1-.947.953.974.974,0,0,1-.947-.953V9.725h.947a.974.974,0,0,1,.947.953Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpDesk);
export default __webpack_public_path__ + "static/media/help_desk.6ee737d08eba38b3f6907d9cdeb24796.svg";
export { ForwardRef as ReactComponent };